// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1___a36d3c2090a67397696{/*!*/}.AutoCompleteResults-cls2___aef079eb85255a6188f{display:flex;flex-direction:column;justify-content:center;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1___a36d3c2090a67397696",
	"cls2": "AutoCompleteResults-cls2___aef079eb85255a6188f AutoCompleteResults-cls1___a36d3c2090a67397696"
};
export default ___CSS_LOADER_EXPORT___;
